import { Search, XCircle } from 'lucide-react';
import { ChangeEvent } from 'react';

import { TextInput } from '@/components/inputs';
import { VisuallyHidden } from '@/components/visually-hidden';
import { tv } from '@/utils/styles';

export interface TextFilterProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
}

const TextFilter = ({ value, placeholder = 'Search...', onChange }: TextFilterProps) => {
  const { searchIcon } = styles();

  return (
    <div className="relative">
      <TextInput
        className="m-0 max-w-48 p-0"
        style={{ paddingLeft: '28px' }}
        placeholder={placeholder}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        value={value}
        hideLabel
        size="small"
        showShadow={false}
      />
      {value ? (
        <button
          className={searchIcon({ className: 'hover:text-errorDark' })}
          type="button"
          onClick={() => onChange('')}
          title="Clear filter"
          aria-label="Clear filter"
        >
          <XCircle className="size-4" />
          <VisuallyHidden>Clear filter</VisuallyHidden>
        </button>
      ) : (
        <Search className={searchIcon()} />
      )}
    </div>
  );
};

const styles = tv({
  slots: {
    searchIcon: 'absolute left-2 top-1/2 size-4 -translate-y-1/2',
  },
});

export { TextFilter };
